export const formatSummaryContent = (content: string) => {
  let formatted = content.replace(/<br\s*\/?>/gi, '\n');

  formatted = formatted.replace(/\n\s*\n/g, '\n\n');

  // Convert numbered lists that start with "1.", "2.", etc. to proper markdown
  formatted = formatted.replace(/^(\d+\.\s+)/gm, '$1');

  // Convert section headers like "Action Items:" to markdown headers
  formatted = formatted.replace(/^([A-Za-z\s]+):\s*$/gm, '### $1');

  return formatted;
};

export const formatTranscriptContent = (content: string) => {
  const lines = content.split('\n');

  const formattedLines = lines.map(line => {
    if (!line.trim()) return '';

    const timestampPattern = /^(\d{2}:\d{2}:\d{2})\s*-\s*(.+?):\s*"(.+)"$/;
    const match = line.match(timestampPattern);
    if (match) {
      const [, timestamp, speaker, quote] = match;
      return `**${timestamp} - ${speaker}:** "${quote}"`;
    }

    return line;
  });

  return formattedLines.join('\n\n');
};
